<script>
import Service from '../../services/clearance-document';
import config from '../../common/genericPanelConf';
import CommonConstants from '../../common/Constants';

import Utils from '../../common/Utils';

import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Dropdown from 'primevue/dropdown';
import Panel from 'primevue/panel';
import Dialog from 'primevue/dialog';
import Toolbar from 'primevue/toolbar';
import Textarea from 'primevue/textarea';
import Checkbox from 'primevue/checkbox';

import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue'
import GenericDateTimeMaskV2 from '../../components/generic/GenericDateTimeMaskV2.vue';

import { required, maxLength, minValue  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { faSearch } from '@fortawesome/free-solid-svg-icons';

export default{
  setup: () => ({ v$: useVuelidate() }),
  components: {
    InputText,
    Checkbox,
    InputNumber,
    Textarea,
    ResponsiveButton,
    DataTable,
    Column,
    Dropdown,
    GenericCustomAutocompleteV2,
    Panel,
    Dialog,
    Toolbar,
    GenericDateTimeMaskV2
},
  data(){
    return {
      idMovementInstructionHeader: null,
      currentVersion: null,
      config: {},
      documentSubmitted: false,
      itemSubmitted: false,
      newVersionSubmitted: false,
      recreateDocumentSubmitted: false,
      measureItemDisabled: false,
      selectedDocument: {type: ''},
      versions: [],
      documents: [],
      documentDetails: {},
      collapseDocumentsPanel: false,
      collapseDocumentDetailsPanel: false,
      collapseDocumentItemsPanel: false,
      measureDialogVisible: false,
      measureItem:{
        'PLZ': {},
        'CQTA': {},
        'RCC': {}
      },
      onlyOpened: true,
      newVersionDialogVisible: false,
      recreateDocumentDialogVisible: false,
      issueDate: null,
      isActive: false,
      isClosed: false,
      activeTab: 0,
      sections: [],
      documentsWithoutNumber: [],
      documentsWithoutNumberDialogVisible: false,
      documentsWithoutNumberCloseDialogVisible: false,
      selectedDocumentsToAssignNumber: [],
      lotListDialogVisible: false,
      selectedLots: [],
      lotsList: [],
      inputValue: '',
      signerForNewVersion: null,
      openDialogBlackProducts: false,
      blackProductsTankList: [],
      tanksToExclude: [],
      selectedTanks: [],
      openDialogBlackProductsRecreate: false
    }
  },
  validations(){
    let validations = {
      measureItem: {},
      documentDetails: {},
      issueDate: {required}
    }

    if(this.config.documentType){
      Object.entries(this.config.documentType).forEach(element => {
        validations.documentDetails[element[0]] = {};
        Object.entries(element[1]).forEach(field => {
          if(field[1].validations) {
            validations.documentDetails[element[0]][field[0]] = {};
          }
          if(field[1].validations?.maxLength) {
            validations.documentDetails[element[0]][field[0]].maxLength = maxLength(field[1].validations.maxLength);
          }
          if(field[1].validations?.required) {
            validations.documentDetails[element[0]][field[0]].required = required;
          }
          if(field[1].validations?.minValue) {
            validations.documentDetails[element[0]][field[0]].minValue = minValue(field[1].validations.minValue);
          }
        })
      });
    }

    if(this.config.documentItems){
      Object.entries(this.config.documentItems).forEach(element => {
        validations.measureItem[element[0]] = {};
        Object.entries(element[1]).forEach(field => {

          if (field[1].validations){
            validations.measureItem[element[0]][field[0]] = {};
          }
          if(field[1].validations?.maxLength) {
            validations.measureItem[element[0]][field[0]].maxLength = maxLength(field[1].validations.maxLength);
          }
          if(field[1].validations?.required) {
            validations.measureItem[element[0]][field[0]].required = required;
          }
          if(field[1].validations?.minValue) {
            validations.measureItem[element[0]][field[0]].minValue = minValue(field[1].validations.minValue);
          }
        })
      });
    }

    return validations;
  },
  created(){
    this.config = config.getConfiguration('ClearanceDocument');
  },
  computed: {
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    },
    activeSections(){
      return this.sections.filter((item) => this.documents?.[item]?.length)
    },
    constants(){
      return CommonConstants;
    },
    isPreviousVersion(){
      return String(this.currentVersion.label) !== this.versions.slice(-1)[0].label;
    },
  },
  mounted() {
    this.$store.dispatch('security/setNavbarTitle', 'issueOfDocuments.page_title');
    this.unsetDocumentDetails();
    
  },
  watch: {
    currentVersion: {
      handler(){
        this.isActive = !this.currentVersion?.extraData.isCancelled && !this.currentVersion?.extraData.isClosed;
        this.isClosed = this.currentVersion?.extraData.isClosed;
        this.loadDocuments();
      },
      deep: true
    },
    selectedDocument() {
      this.documentDetails[this.selectedDocument.type] = {};
      if (this.selectedDocument.type != 'DAA') {
        this.collapseDocumentsPanel = true;
        this.collapseDocumentDetailsPanel = false;
        this.collapseDocumentItemsPanel = false;
        this.handleDocumentDetails(false);
      } else {
        const routeData = this.$router.resolve({name: 'daa', query: {id: this.selectedDocument.id}});
        window.open(routeData.href, '_blank');
      }
    },
    onlyOpened(){
      this.$refs.voyageCombo.loadOptions('movement-instruction/voyage-number-combo?getOnlyOpened=' + this.onlyOpened);
    }
  },
  methods: {
    onVoyageSelected(event){
      console.log('onVoyageSelected', event)
      this.currentVersion = null;
      if (event.value) {
        this.idMovementInstructionHeader = event.value.value;
        this.documents = [];
        this.selectedDocument = {type: ''};
        this.documentDetails[this.selectedDocument.type] = {};
        this.loadVersions();
      }
    },
    unsetDocumentDetails(){
      this.documentDetails = {
        'PLZ': {},
        'CM': {},
        'CQTA': {},
        'NP': {},
        'BEM': {},
        'RCD': {},
        'RCC': {},
        'SHT': {},
        'XAB': {},
      }
    },
    loadVersions(){
      this.$store.dispatch("generic/setLoading", true);
      Service.getClearanceDocumentVersion({idMovementInstructionHeader: this.idMovementInstructionHeader}, ({data}) => {
        this.$store.dispatch("generic/setLoading", false);
        if(data.length){
          this.versions = data;
          [this.currentVersion] = this.versions.slice(-1);
        }else{
          this.versions = [];
          Service.getClearanceDocumentProposalVersion({idMovementInstructionHeader: this.idMovementInstructionHeader}, ({data, success}) => {
            if(success){
              if(data){
                this.issueDate = this.utils.dateToCurrentTimeZone(data.issueDate)
                this.signerForNewVersion = data.signer;
                this.newVersionDialogVisible = true;
              }
            }else{
              
              this.$toast.add({detail: this.$t('issueOfDocuments.noVersionsFound'), life:3000, severity:'error'});
            }
          })
        }
      })
    },
    createNewVersion(){      
      this.newVersionSubmitted = true;
      this.newVersionDialogVisible = false;
      this.openDialogBlackProducts = false;
      Service.createClearanceDocumentVersion({idMovementInstructionHeader: this.idMovementInstructionHeader, voyageNumber: 'L', issueDate: this.issueDate, signer: this.signerForNewVersion, tanksToBeExcluded: this.tanksToExclude}, ({success}) => {
        if(success){
          this.loadVersions();
        }
      })
    },
    recreateDocument(){
      Service.getClearanceDocumentProposalVersion({idMovementInstructionHeader: this.idMovementInstructionHeader}, ({data, success}) => {
        if(success){
          if(data){
            this.issueDate = this.utils.dateToCurrentTimeZone(data.issueDate);
            this.recreateDocumentDialogVisible = true;
            this.signerForNewVersion = data.signer;
          }
        }else{
          this.$toast.add({detail: this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      })
    },
    confirmClose(){
      this.$confirm.require({
                message: this.$t('issueOfDocuments.confirmCloseVoyage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                  this.documentsWithoutNumberCloseDialogVisible = false;
                  this.$store.dispatch("generic/setLoading", true);
                  Service.closeClearanceDocumentVersion({id: this.idMovementInstructionHeader}, ({success, message}) => {
                  this.$store.dispatch("generic/setLoading", false);
                    if(success){
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                      this.loadVersions();
                    } else {
                      if(message === ""){
                        this.$toast.add({detail: this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                      }
                      else{
                        this.$toast.add({detail: message, life:3000, severity:'error'});
                      }
                    }
                  })   
                },
                reject: () => {
                    this.$confirm.close();
                }
            });
    },
    closeDocument(){
      Service.getClearanceDocumentVersionWithoutNumber(this.currentVersion.value, ({success, data}) => {
        if(success){
          if(!data.length){
            this.confirmClose();
          } else {
            this.documentsWithoutNumberCloseDialogVisible = true;
            this.documentsWithoutNumber = data;
          }
        }
      });


      
    },
    reOpenDocument(){
      this.$store.dispatch("generic/setLoading", true);
      Service.reopenClearanceDocumentVersion({id: this.idMovementInstructionHeader}, ({success}) => {
      this.$store.dispatch("generic/setLoading", false);
        if(success){
        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          this.loadVersions();
        } else {
          this.$toast.add({detail: this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      })
    },
    submitPrintFascicolata(){
      this.$store.dispatch("generic/setLoading", true);
      const lotList = this.selectedLots.map((item) => item.lotId).join(',');

      Service.printClearanceDocumentFascicolata({lotList}, this.printCallback(null));
    },
    printFascicle(){
      Service.getClearanceDocumentVersionWithoutNumber(this.currentVersion.value, ({success, data}) => {
        if(success){
          if(!data.length){
            Service.getClearanceDocumentLotsByVersion(this.currentVersion.value, ({success, data, message}) => {
              if(success){
                this.lotsList = data;
                this.lotListDialogVisible = true;
              } else {
                this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            });
          } else {
            this.documentsWithoutNumberDialogVisible = true;
            this.documentsWithoutNumber = data;
          }
        }
      });
    },
    submitRecreateDocument(){
      this.recreateDocumentSubmitted = true;
      this.recreateDocumentDialogVisible = false;
      this.openDialogBlackProductsRecreate = false;
      this.$store.dispatch("generic/setLoading", true);
      Service.cancelAndRecreateClearanceDocumentVersion({idMovementInstructionHeader: this.idMovementInstructionHeader, voyageNumber: "L", id: this.currentVersion.value, issueDate: this.issueDate, signer: this.signerForNewVersion, tanksToBeExcluded: this.tanksToExclude}, ({success}) => {
        this.$store.dispatch("generic/setLoading", false);
        if(success){
          this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          this.loadVersions();
        } else {
          this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      })
    },
    loadDocuments() {
      this.collapseDocumentsPanel = false;
      this.unsetDocumentDetails();
      this.$store.dispatch("generic/setLoading", true);
      if (this.idMovementInstructionHeader && (this.currentVersion?.label)) {
        Service.getClearanceDocumentSummary({idMovementInstructionHeader: this.idMovementInstructionHeader, versionNumber: this.currentVersion.label}, ({success, data}) => {
          if(success){
            Service.getClearanceDocumentSectionCombo({getOnlyValid: true},({success, data:documentSections}) => {
              if(success){
                this.sections = documentSections.map((item) => item.label);
                this.documents = 
                data.reduce((acc, curr) => {
                  const section = this.sections.find((item)=> item === curr.documentSection) || 'Other';
                  return {...acc, [section]: [...acc[section], curr]};
                }, 
                Object.fromEntries(this.sections.map((item) => [item, []])));
              }
            })
          }
          this.$store.dispatch("generic/setLoading", false);
        })
      }
    },
    showToast(success, message) {
      if(success){
        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
      }else{
        this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
      }
    },
    updateItem(item) {
      switch(this.selectedDocument.type) {
        case 'PLZ':
          item.idClearanceDocumentBillOfLading = this.documentDetails[this.selectedDocument.type].id;
          item.quantity || (item.quantity = 0);
          Service.updateClearanceDocumentBillOfLadingItem(item, ({success, message}) => {
            if(success) {
              this.measureDialogVisible = false;
              this.handleDocumentDetails(false);
            }
            this.itemSubmitted = false;
            this.measureItemDisabled = false;
            this.showToast(success, message);
          })
          break;
        case 'CQTA':
          item.idClearanceDocumentCertificateOfQuantity = this.documentDetails[this.selectedDocument.type].id;
          Service.updateClearanceDocumentCertificateOfQuantityItem(item, ({success, message}) => {
            if(success) {
              this.measureDialogVisible = false;
              this.handleDocumentDetails(false);
            }
            this.itemSubmitted = false;
            this.measureItemDisabled = false;
            this.showToast(success, message);
          })
          break;
        case 'RCC':
          item.idClearanceDocumentMasterReceiptSamples = this.documentDetails[this.selectedDocument.type].id;
          Service.updateClearanceDocumentMasterReceiptSamplesItem(item, ({success, message}) => {
            if(success) {
              this.measureDialogVisible = false;
              this.handleDocumentDetails(false);
            }
            this.itemSubmitted = false;
            this.measureItemDisabled = false;
            this.showToast(success, message);
          })
          break;
      }
    },
    createItem(item) {
      switch(this.selectedDocument.type) {
        case 'PLZ':
          item.idClearanceDocumentBillOfLading = this.documentDetails[this.selectedDocument.type].id;
          Service.createClearanceDocumentBillOfLadingItem(item, ({success, message}) => {
            if (success) {
              this.measureDialogVisible = false;
              this.handleDocumentDetails(false);
            }
            this.itemSubmitted = false;
            this.measureItemDisabled = false;
            this.showToast(success, message);
          })
          break;
        case 'CQTA':
          item.idClearanceDocumentCertificateOfQuantity = this.documentDetails[this.selectedDocument.type].id;
          Service.createClearanceDocumentCertificateOfQuantityItem(item, ({success, message}) => {
            if (success) {
              this.measureDialogVisible = false;
              this.handleDocumentDetails(false);
            }
            this.itemSubmitted = false;
            this.measureItemDisabled = false;
            this.showToast(success, message);
          })
          break;
        case 'RCC':
          item.idClearanceDocumentMasterReceiptSamples = this.documentDetails[this.selectedDocument.type].id;
          Service.createClearanceDocumentMasterReceiptSamplesItem(item, ({success, message}) => {
            if (success) {
              this.measureDialogVisible = false;
              this.handleDocumentDetails(false);
            }
            this.itemSubmitted = false;
            this.measureItemDisabled = false;
            this.showToast(success, message);
          })
          break;
      }
    },
    openMeasureUnitDialog(){
      this.measureItem[this.selectedDocument.type] = {
        id: null,
        quantity: 0
      }
      this.measureDialogVisible = true;
    },
    submitSaveMeasureUnit(){
      this.itemSubmitted = true;
      if(!this.v$.measureItem[this.selectedDocument.type].$invalid){
        this.measureItemDisabled = true;
        if(this.measureItem[this.selectedDocument.type].id){
          this.updateItem(this.measureItem[this.selectedDocument.type]);
        }else{
          this.createItem(this.measureItem[this.selectedDocument.type]);
        }
      }
    },
    openMeasureUnitDialogEdit(data){
      this.measureItem[this.selectedDocument.type] = data;
      this.measureDialogVisible = true;
    },
    closeDialog() {
      this.measureDialogVisible = false;
      this.itemSubmitted = false;
      this.handleDocumentDetails(false);
    },
    onChangeCombo(e, field) {

      // try{
      //   console.log('e', e)
      //   console.log('measureItem', this.measureItem[this.selectedDocument.type])
      //   console.log('index', this.config.documentItems[this.selectedDocument.type][field].refLabel)
      //   console.log('v', this.measureItem[this.selectedDocument.type][this.config.documentItems[this.selectedDocument.type][field].refLabel])
      // }catch(er){
      //   console.log(er)
      // }

      if(field){
        this.measureItem[this.selectedDocument.type][this.config.documentItems[this.selectedDocument.type][field].refLabel] = e.value ? e.value.label : null;
      }

      if(field === 'uoMCode' && this.selectedDocument.type !== 'RCC') {
        this.measureItem[this.selectedDocument.type].movementInstructionLotUoMDescription = e.value ? e.value.label : null;
        
        let params = {
          densityAt15CDeg : this.documentDetails[this.selectedDocument.type]?.densityAt15CDeg,
          weightInMtAir: this.documentDetails[this.selectedDocument.type]?.weightInMtAir,
          volumeInM3At15CDeg: this.documentDetails[this.selectedDocument.type]?.volumeInM3At15CDeg,
          unitOfMeasure: e.value ? e.value.value : null
        }

        Service.getClearanceDocumentConversion(params, ({data, success}) => {
          if(success){
            this.measureItem[this.selectedDocument.type].quantity = data.quantity || 0;
            this.measureItem[this.selectedDocument.type].conversionFactor = data.conversionFactor || 0;
          } else {
            this.measureItem[this.selectedDocument.type].quantity = 0;
            this.measureItem[this.selectedDocument.type].conversionFactor = 0;
          }
        })
      }
    },
    onDeleteMeasureUnit(data, event){
      this.$confirm.require({
        target: event.currentTarget,
        message: this.$t('messages.delete_message_question'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {
          switch(this.selectedDocument.type) {
            case 'PLZ':
              Service.deleteClearanceDocumentBillOfLadingItem(data.id, 
                response => {
                  if(response.success){
                    this.handleDocumentDetails(false);
                    this.$confirm.close();
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                  }
                  else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                  }
                }
              )
              break;
            case 'CQTA':
              Service.deleteClearanceDocumentCertificateOfQuantityItem(data.id, 
                response => {
                  if(response.success){
                    this.handleDocumentDetails(false);
                    this.$confirm.close();
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                  }
                  else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                  }
                }
              )
              break;
            case 'RCC':
              Service.deleteClearanceDocumentMasterReceiptSamplesItem(data.id, 
                response => {
                  if(response.success){
                    this.handleDocumentDetails(false);
                    this.$confirm.close();
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                  }
                  else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                  }
                }
              )
              break;
            default:
              break;
          }
        },
        reject: () => {
            this.$confirm.close();
        }
      });
    },
    assignLocalNumberToSelectedDocuments(){
      this.selectedDocumentsToAssignNumber.forEach((item) => {
        item.id = item.idDocument;
        item.type = item.documentTypeCode;
        this.assignLocalNumber(item);
        this.documentsWithoutNumberDialogVisible = false;
        this.documentsWithoutNumberCloseDialogVisible = false;
        this.selectedDocumentsToAssignNumber = [];
      })
    },
    assignLocalNumber(data, event){
      if (data.code) {
        this.$confirm.require({
        target: event.currentTarget,
        message: this.$t('messages.assignNewDocumentNumber'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {
          switch(data.type) {
            case 'DAA':
              Service.assignClearanceDocumentDAALocalNumber({id: data.id}, (response) =>{
                if(response.success){
                  this.$confirm.close();
                  this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                  this.loadDocuments();
                }
                else{
                  this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
              })
              break;
            case 'PLZ':
              Service.assignClearanceDocumentPLZDocumentNumber({id: data.id}, (response) =>{
                if(response.success){
                  this.$confirm.close();
                  this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                  this.loadDocuments();
                }
                else{
                  this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
              })
              break;
            case 'NP':
              Service.assignClearanceDocumentNPDocumentNumber({id: data.id}, (response) =>{
                if(response.success){
                  this.$confirm.close();
                  this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                  this.loadDocuments();
                }
                else{
                  this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
              })
              break;
            case 'XAB':
              Service.assignClearanceDocumentXABDocumentNumber({id: data.id}, (response) =>{
                if(response.success){
                  this.$confirm.close();
                  this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                  this.loadDocuments();
                }
                else{
                  this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
              })
              break;
            case 'BEM':
              Service.assignClearanceDocumentBEMDocumentNumber({id: data.id}, (response) =>{
                if(response.success){
                  this.$confirm.close();
                  this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                  this.loadDocuments();
                }
                else{
                  this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
              })
              break;
            default:
              break;
          }
        },
        reject: () => {
            this.$confirm.close();
        }});
      } else {
        switch(data.type) {
          case 'DAA':
            Service.assignClearanceDocumentDAALocalNumber({id: data.id}, (response) =>{
              if(response.success){
                this.$confirm.close();
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                this.loadDocuments();
              }
              else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            })
            break;
          case 'PLZ':
            Service.assignClearanceDocumentPLZDocumentNumber({id: data.id}, (response) =>{
              if(response.success){
                this.$confirm.close();
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                this.loadDocuments();
              }
              else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            })
            break;
          case 'NP':
            Service.assignClearanceDocumentNPDocumentNumber({id: data.id}, (response) =>{
              if(response.success){
                this.$confirm.close();
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                this.loadDocuments();
              }
              else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            })
            break;
          case 'XAB':
            Service.assignClearanceDocumentXABDocumentNumber({id: data.id}, (response) =>{
              if(response.success){
                this.$confirm.close();
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                this.loadDocuments();
              }
              else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            })
            break;
          case 'BEM':
            Service.assignClearanceDocumentBEMDocumentNumber({id: data.id}, (response) =>{
              if(response.success){
                this.$confirm.close();
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                this.loadDocuments();
              }
              else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            })
            break;
          default:
            break;
        }
      }
    },
    print(data, isPreview){
      this.$store.dispatch("generic/setLoading", true);

      switch(data.type) {
          case 'PLZ':
            if(isPreview){
              Service.printPreviewClearanceDocumentBillOfLading({id: data.id}, this.printCallback(data));
            }else {
              Service.printClearanceDocumentBillOfLading({id: data.id}, this.printCallback(data));
            }
            break;
          case 'CM':
            if(isPreview){
              Service.printPreviewClearanceDocumentCargoManifest({id: data.id}, this.printCallback(data));
            }else {
              Service.printClearanceDocumentCargoManifest({id: data.id}, this.printCallback(data));
            }
            break;
          case 'CQTA':
            if(isPreview){
              Service.printPreviewClearanceDocumentCertificateOfQuantity({id: data.id}, this.printCallback(data));
            }else {
              Service.printClearanceDocumentCertificateOfQuantity({id: data.id}, this.printCallback(data));
            }
            break;
          case 'NP':
            if(isPreview){
              Service.printPreviewClearanceDocumentDeliveryNote({id: data.id}, this.printCallback(data));
            }else {
              Service.printClearanceDocumentDeliveryNote({id: data.id}, this.printCallback(data));
            }
            break;
          case 'BEM':
            if(isPreview){
              Service.printPreviewClearanceDocumentGoodsReceiptNote({id: data.id}, this.printCallback(data));
            }else {
              Service.printClearanceDocumentGoodsReceiptNote({id: data.id}, this.printCallback(data));
            }
            break;
          case 'RCD':
            if(isPreview){
              Service.printPreviewClearanceDocumentMasterReceiptDocuments({id: data.id}, this.printCallback(data));
            }else {
              Service.printClearanceDocumentMasterReceiptDocuments({id: data.id}, this.printCallback(data));
            }
            break;
          case 'RCC':
            if(isPreview){
              Service.printPreviewClearanceDocumentMasterReceiptSamples({id: data.id}, this.printCallback(data));
            }else {
              Service.printClearanceDocumentMasterReceiptSamples({id: data.id}, this.printCallback(data));
            }
            break;
          case 'SHT':
            if(isPreview){
              Service.printPreviewClearanceDocumentShoreTank({id: data.id}, this.printCallback(data));
            }else {
              Service.printClearanceDocumentShoreTank({id: data.id}, this.printCallback(data));
            }
            break;
          case 'DAA':
            if(isPreview){
              Service.printPreviewClearanceDocumentDAA({id: data.id}, this.printCallback(data));
            }else {
              Service.printClearanceDocumentDAA({id: data.id}, this.printCallback(data));
            }
            break;
          case 'XAB':
            if(isPreview){
              Service.printPreviewClearanceDocumentXAB({id: data.id}, this.printCallback(data));
            }else {
              Service.printClearanceDocumentXAB({id: data.id}, this.printCallback(data));
            }
            break;
          default:
            this.$store.dispatch("generic/setLoading", false);
            this.$toast.add({detail: this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            break;
        }
    },
    printCallback(data){
      return (response) => {
        this.$store.dispatch("generic/setLoading", false);
        if(response.success){
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
      
          fileLink.href = fileURL;
          if(data?.type && data?.id){
            fileLink.setAttribute('download', data.type + data.id +'.pdf');
          }else{
            fileLink.setAttribute('download', 'fascicolata.pdf');
          }
          document.body.appendChild(fileLink);
      
          fileLink.click();
        }else{
          this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      }
    },
    handleInput() {
      this.$nextTick(() => {
        this.$refs.inputRef[0].$el.focus();
      });
    },
    handleDocumentDetails(update) {
      update && (this.documentSubmitted = true);
      if(!update || !this.v$.documentDetails[this.selectedDocument.type].$invalid){
        switch(this.selectedDocument.type) {
            // case 'PLZ':
          case 'PLZ':
            update ?
            Service.updateClearanceDocumentBillOfLading(this.documentDetails[this.selectedDocument.type], ({success, message}) => {this.loadDocuments(); this.showToast(success, message)}) :
            Service.getClearanceDocumentBillOfLading(this.selectedDocument.id, ({success, data}) => {

              if(success) { 
                this.documentDetails[this.selectedDocument.type] = data;
                if(this.documentDetails[this.selectedDocument.type].charterPartyDated){
                  this.documentDetails[this.selectedDocument.type].charterPartyDated = Utils.dateToCurrentTimeZone(this.documentDetails[this.selectedDocument.type].charterPartyDated);
                } else {
                  this.documentDetails[this.selectedDocument.type].charterPartyDated = null;
                }
              } else {
                this.documentDetails[this.selectedDocument.type] = {};
              }

            })
            break;
            // case 'CM':
          case 'CM':
            update ?
            Service.updateClearanceDocumentCargoManifest(this.documentDetails[this.selectedDocument.type], ({success, message}) => {this.loadDocuments(); this.showToast(success, message)}) :
            Service.getClearanceDocumentCargoManifest(this.selectedDocument.id, ({success, data}) => (success ? (this.documentDetails[this.selectedDocument.type] = data) : (this.documentDetails[this.selectedDocument.type] = {})))
            break;
            // case 'CQTA':
          case 'CQTA':
            update ?
            Service.updateClearanceDocumentCertificateOfQuantity(this.documentDetails[this.selectedDocument.type], ({success, message}) => {this.loadDocuments(); this.showToast(success, message)}) :
            Service.getClearanceDocumentCertificateOfQuantity(this.selectedDocument.id, ({success, data}) => (success ? (this.documentDetails[this.selectedDocument.type] = data) : (this.documentDetails[this.selectedDocument.type] = {})))
            break;
            // case 'NP':
          case 'NP':
            update ?
            Service.updateClearanceDocumentDeliveryNote(this.documentDetails[this.selectedDocument.type], ({success, message}) => {this.loadDocuments(); this.showToast(success, message)}) :
            Service.getClearanceDocumentDeliveryNote(this.selectedDocument.id, ({success, data}) => (success ? (this.documentDetails[this.selectedDocument.type] = data) : (this.documentDetails[this.selectedDocument.type] = {})))
            break;
            // case '':
          case 'BEM':
            update ?
            Service.updateClearanceDocumentGoodsReceiptNote(this.documentDetails[this.selectedDocument.type], ({success, message}) => {this.loadDocuments(); this.showToast(success, message)}) :
            Service.getClearanceDocumentGoodsReceiptNote(this.selectedDocument.id, ({success, data}) => (success ? (this.documentDetails[this.selectedDocument.type] = data) : (this.documentDetails[this.selectedDocument.type] = {})))
            break;
            // case 'RCD':
          case 'RCD':
            update ?
            Service.updateClearanceDocumentMasterReceiptDocuments(this.documentDetails[this.selectedDocument.type], ({success, message}) => {this.loadDocuments(); this.showToast(success, message)}) :
            Service.getClearanceDocumentMasterReceiptDocuments(this.selectedDocument.id, ({success, data}) => (success ? (this.documentDetails[this.selectedDocument.type] = data) : (this.documentDetails[this.selectedDocument.type] = {})))
            break;
            // case 'RCC':
          case 'RCC':
            update ?
            Service.updateClearanceDocumentMasterReceiptSamples(this.documentDetails[this.selectedDocument.type], ({success, message}) => {this.loadDocuments(); this.showToast(success, message)}) :
            Service.getClearanceDocumentMasterReceiptSamples(this.selectedDocument.id, ({success, data}) => (success ? (this.documentDetails[this.selectedDocument.type] = data) : (this.documentDetails[this.selectedDocument.type] = {})))
            break;
            // case 'SHT':
          case 'SHT':
            update ?
            Service.updateClearanceDocumentShoreTank(this.documentDetails[this.selectedDocument.type], ({success, message}) => {this.loadDocuments(); this.showToast(success, message)}) :
            Service.getClearanceDocumentShoreTank(this.selectedDocument.id, ({success, data}) => (success ? (this.documentDetails[this.selectedDocument.type] = data) : (this.documentDetails[this.selectedDocument.type] = {})))
            break;
          case 'XAB':
            update ?
            Service.updateClearanceDocumentXAB(this.documentDetails[this.selectedDocument.type], ({success, message}) => {this.loadDocuments(); this.showToast(success, message)}) :
            Service.getClearanceDocumentXAB(this.selectedDocument.id, ({success, data}) => (success ? (this.documentDetails[this.selectedDocument.type] = data) : (this.documentDetails[this.selectedDocument.type] = {})))
            break;
          default:
            this.documentDetails[this.selectedDocument.type] = {};
        }
      }
    },
    checkBlackProductsTank(){
      this.tanksToExclude = [];
      this.newVersionSubmitted = true;
      this.newVersionDialogVisible = false;
      Service.checkClearanceDocumentBlackProducts(this.idMovementInstructionHeader, response => {
        if(response.success && response.data){
          if(response.data.openDialog){
            this.openDialogBlackProducts = response.data.openDialog;
            this.blackProductsTankList = response.data.tanks;
            this.selectedTanks = this.blackProductsTankList;
          }else{
            this.createNewVersion();
          }
        }
      });
    },
    checkBlackProductsTankRecreate(){
      this.tanksToExclude = [];
      this.recreateDocumentSubmitted = true;
      this.recreateDocumentDialogVisible = false;
      Service.checkClearanceDocumentBlackProducts(this.idMovementInstructionHeader, response => {
        if(response.success && response.data){
          if(response.data.openDialog){
            this.openDialogBlackProductsRecreate = response.data.openDialog;
            this.blackProductsTankList = response.data.tanks;
            this.selectedTanks = this.blackProductsTankList;
          }else{
            this.submitRecreateDocument();
          }
        }
      });
    },
    onTankUnSelect(data){
      this.tanksToExclude.push(data.data.equipmentCode);
    },
    onTankSelect(data){
      this.tanksToExclude.pop(data.data.equipmentCode);
    }
  }
}

</script>

<template> 
  <main>
    <Dialog v-model:visible="newVersionDialogVisible" modal class="p-fluid" :closable="false">
      <div class="grid">
        <div class="field col-12">
          <i class="pi pi-exclamation-triangle mr-2 text-orange-400"></i><span class="text-orange-400"><b>{{ this.$t('issueOfDocuments.warningCreateNewVersion') }}</b></span>
          <label :class="{'p-error': v$.issueDate.$invalid && newVersionSubmitted, 'block mt-3': true}">{{$t('issueOfDocuments.issueDate')}}</label>              
          <Calendar
            v-model="issueDate" 
            :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
            :dateFormat="constants.DATE_FORMAT_POINT"
            :showTime="false"
            :showIcon="true" :showButtonBar="true" :yearNavigator="true"
            :class="{'p-invalid': v$.issueDate.$invalid && newVersionSubmitted, 'w-full p-inputtext-sm mt-1 ': true}" />
          <div v-if="(v$.issueDate.$invalid && newVersionSubmitted) || v$.issueDate.$pending.$response">
            <small class="p-error" v-for="error in v$.issueDate.$silentErrors" :key="error.$validator">
                {{error.$message}}
            </small>
          </div>
        </div>
        <div class="field col-12">
          <label :class="{'block mt-3': true}">{{$t('issueOfDocuments.signer')}}</label>              
          <InputText v-model="signerForNewVersion" :class="{'w-full p-inputtext-sm mt-1 ': true}" />
        </div>
      </div>
      <template #footer>
        <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text p-button-danger" @click="newVersionDialogVisible = false, newVersionSubmitted = false"/>
        <ResponsiveButton :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="checkBlackProductsTank" />
      </template>
    </Dialog>
    <Dialog v-model:visible="recreateDocumentDialogVisible" modal class="p-fluid" :closable="false">
      <div class="grid">
        <div class="field col-12">
          <i class="pi pi-exclamation-triangle mr-2 text-red"></i><span class="text-red"><b>{{ this.$t('issueOfDocuments.dangerRecreateDocument') }}</b></span>
          <label :class="{'p-error': v$.issueDate.$invalid && recreateDocumentSubmitted, 'block mt-3': true}">{{$t('issueOfDocuments.issueDate')}}</label>              
          <Calendar
            v-model="issueDate" 
            :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
            :dateFormat="constants.DATE_FORMAT_POINT"
            :showTime="false"
            :showIcon="true" :showButtonBar="true" :yearNavigator="true"
            :class="{'p-invalid': v$.issueDate.$invalid && recreateDocumentSubmitted, 'w-full p-inputtext-sm mt-1 ': true}" />
          <div v-if="(v$.issueDate.$invalid && recreateDocumentSubmitted) || v$.issueDate.$pending.$response">
            <small class="p-error" v-for="error in v$.issueDate.$silentErrors" :key="error.$validator">
                {{error.$message}}
            </small>
          </div>
        </div>
        <div class="field col-12">
          <label :class="{'block mt-3': true}">{{$t('issueOfDocuments.signer')}}</label>              
          <InputText v-model="signerForNewVersion" :class="{'w-full p-inputtext-sm mt-1 ': true}" />
        </div>
      </div>
      <template #footer>
        <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text p-button-danger" @click="recreateDocumentDialogVisible = false, recreateDocumentSubmitted = false"/>
        <ResponsiveButton :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="checkBlackProductsTankRecreate()" />
      </template>
    </Dialog>
    <Dialog v-model:visible="documentsWithoutNumberDialogVisible" modal class="p-fluid" :closable="false">
      <div class="grid">
        <div class="field col-12">
          <i class="pi pi-exclamation-triangle mr-2 text-red"></i><span class="text-red"><b>{{ this.$t('issueOfDocuments.documentsWithoutNumber') }}</b></span>
          <DataTable :value="documentsWithoutNumber" showGridlines stripedRows class="p-datatable-sm mt-3" responsiveLayout="scroll" v-model:selection="selectedDocumentsToAssignNumber">
            <Column selectionMode="multiple" headerStyle="width: 3em" :reorderableColumn="false"></Column>
            <Column field="documentType" :header="$t('documentType.fk')" :sortable="true">
              <template #body="element">
                {{element.data.documentType}}
              </template>
            </Column>
            <Column field="lotCode" :header="$t('lotCode')" :sortable="true">
              <template #body="element">
                {{element.data.lotCode}}
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <template #footer>
        <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text p-button-danger" @click="documentsWithoutNumberDialogVisible = false; this.selectedDocumentsToAssignNumber = []"/>
        <ResponsiveButton :label="$t('btn.assign')" icon="pi pi-check" class="p-button-text" @click="assignLocalNumberToSelectedDocuments" />
      </template>
    </Dialog>
    <Dialog v-model:visible="documentsWithoutNumberCloseDialogVisible" modal class="p-fluid" :closable="false">
      <div class="grid">
        <div class="field col-12">
          <i class="pi pi-exclamation-triangle mr-2 text-red"></i><span class="text-red"><b>{{ this.$t('issueOfDocuments.documentsWithoutNumberClose') }}</b></span>
          <DataTable :value="documentsWithoutNumber" showGridlines stripedRows class="p-datatable-sm mt-3" responsiveLayout="scroll" v-model:selection="selectedDocumentsToAssignNumber">
            <Column selectionMode="multiple" headerStyle="width: 3em" :reorderableColumn="false"></Column>
            <Column field="documentType" :header="$t('documentType.fk')" :sortable="true">
              <template #body="element">
                {{element.data.documentType}}
              </template>
            </Column>
            <Column field="lotCode" :header="$t('lotCode')" :sortable="true">
              <template #body="element">
                {{element.data.lotCode}}
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <template #footer>
        <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text p-button-danger" @click="documentsWithoutNumberCloseDialogVisible = false; this.selectedDocumentsToAssignNumber = []"/>
        <ResponsiveButton :label="$t('btn.assign')" icon="pi pi-check" class="p-button-text" @click="assignLocalNumberToSelectedDocuments" />
        <ResponsiveButton :label="$t('btn.close')" icon="pi pi-lock" class="p-button-text p-button-success" @click="confirmClose" />
      </template>
    </Dialog>
    <Dialog v-model:visible="lotListDialogVisible" modal class="p-fluid" :closable="false">
      <div class="grid">
        <div class="field col-12">
          <span><b>{{ this.$t('issueOfDocuments.lotsListToPrintFascicle') }}</b></span>
          <DataTable :value="lotsList" showGridlines stripedRows class="p-datatable-sm mt-3" responsiveLayout="scroll" v-model:selection="selectedLots">
            <Column selectionMode="multiple" headerStyle="width: 3em" :reorderableColumn="false"></Column>
            <Column field="lotCode" :header="$t('issueOfDocuments.lot')" :sortable="true">
              <template #body="element">
                {{element.data.lotCode}}
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <template #footer>
        <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text p-button-danger" @click="lotListDialogVisible = false; this.selectedLots = []"/>
        <ResponsiveButton :label="$t('btn.print')" icon="pi pi-check" class="p-button-text" @click="submitPrintFascicolata" />
      </template>
    </Dialog>
    <Dialog v-model:visible="measureDialogVisible" modal :closable="false" class="p-fluid">
      <template v-for="(key, index) in Object.keys(documentDetails[this.selectedDocument.type])" :key="'h_' + index">
          <template v-for="(item, index2) in Array.isArray(documentDetails[this.selectedDocument.type][key]) && documentDetails[this.selectedDocument.type][key].length ? Object.entries(documentDetails[this.selectedDocument.type][key][0]) : []" :key="'c_' + index2">
            <template v-if="!config.documentItems[this.selectedDocument.type][item[0]]?.hidden">
              <template 
                v-if="(config.documentItems[this.selectedDocument.type][item[0]]?.type === 'text' ||
                  config.documentItems[this.selectedDocument.type][item[0]]?.type === 'number')">
                  <div class="field">
                    <label :class="{'p-error':v$.measureItem[this.selectedDocument.type][item[0]]?.$invalid && itemSubmitted}">{{$t('issueOfDocuments.' + this.selectedDocument.type + '.items.' + item[0])}}</label>
                    <InputNumber v-if="config.documentItems[this.selectedDocument.type][item[0]]?.type === 'number'"
                      mode="decimal" :maxFractionDigits="5"
                      v-model="measureItem[this.selectedDocument.type][item[0]]"
                      :class="{'p-invalid':v$.measureItem[this.selectedDocument.type][item[0]]?.$invalid && itemSubmitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <InputText v-else
                      ref="inputRef"
                      v-model="measureItem[this.selectedDocument.type][item[0]]"
                      :class="{'p-invalid':v$.measureItem[this.selectedDocument.type][item[0]]?.$invalid && itemSubmitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <div v-if="(v$.measureItem[this.selectedDocument.type][item[0]]?.$invalid && itemSubmitted) || v$.measureItem[this.selectedDocument.type][item[0]]?.$pending.$response">
                      <small class="p-error" v-for="error in v$.measureItem[this.selectedDocument.type][item[0]]?.$silentErrors" :key="error.$validator">
                          {{error.$message}}
                      </small>
                    </div>
                  </div>
              </template>
              <template v-else>
                <template v-if="config.documentItems[this.selectedDocument.type][item[0]]?.type === 'comboKey'">
                  <div class="field">
                    <label :class="{'p-error':v$.measureItem[this.selectedDocument.type][item[0]]?.$invalid && itemSubmitted}">{{$t('issueOfDocuments.' + this.selectedDocument.type + '.items.' + item[0])}}</label>
                    <InputText
                      v-if="measureItem[this.selectedDocument.type].id"
                      :disabled="true"
                      v-model="measureItem[this.selectedDocument.type][item[0]]"
                      class="w-full p-inputtext-sm mt-1" />
                    <GenericCustomAutocompleteV2
                      v-else
                      :name="item[0]"
                      v-model="measureItem[this.selectedDocument.type][item[0]]" 
                      :onItemSelect="onChangeCombo"
                      :field="item[0]"
                      :disableStore="true"
                      :api="config.documentItems[this.selectedDocument.type][item[0]].api"
                      :disabled="Boolean(measureItem[this.selectedDocument.type].id)"
                      :format="{ label: 'label', value: 'value' }"
                      :class="{'p-invalid':v$.measureItem[this.selectedDocument.type][item[0]]?.$invalid && itemSubmitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <div v-if="(v$.measureItem[this.selectedDocument.type][item[0]]?.$invalid && itemSubmitted) || v$.measureItem[this.selectedDocument.type][item[0]]?.$pending.$response">
                      <small class="p-error" v-for="error in v$.measureItem[this.selectedDocument.type][item[0]]?.$silentErrors" :key="error.$validator">
                          {{error.$message}}
                      </small>
                    </div>
                  </div>
                </template>
                <template v-if="config.documentItems[this.selectedDocument.type][item[0]]?.type === 'comboValue'">
                  <div class="field" v-show="false">
                    <label :class="{'p-error':v$.measureItem[this.selectedDocument.type][item[0]]?.$invalid && itemSubmitted}">{{$t('issueOfDocuments.' + this.selectedDocument.type + '.items.' + item[0])}}</label>
                    <InputText
                      v-model="measureItem[this.selectedDocument.type][item[0]]"
                      :class="{'p-invalid':v$.measureItem[this.selectedDocument.type][item[0]]?.$invalid && itemSubmitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <div v-if="(v$.measureItem[this.selectedDocument.type][item[0]]?.$invalid && itemSubmitted) || v$.measureItem[this.selectedDocument.type][item[0]]?.$pending.$response">
                      <small class="p-error" v-for="error in v$.measureItem[this.selectedDocument.type][item[0]]?.$silentErrors" :key="error.$validator">
                          {{error.$message}}
                      </small>
                    </div>
                  </div>
                </template>
              </template>
            </template>
        </template>
      </template>
      <template #footer>
        <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text" @click="closeDialog"/>
        <ResponsiveButton :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="submitSaveMeasureUnit" :disabled="measureItemDisabled" />
      </template>
    </Dialog>
    <Dialog v-model:visible="openDialogBlackProducts" modal class="p-fluid" :closable="false" :style="{ width: '50rem' }">
      <div class="grid">
        <div class="field col-12">
          <span><b>{{ this.$t('issueOfDocuments.blackProductsTank') }}</b></span>
          <DataTable :value="blackProductsTankList" showGridlines stripedRows class="p-datatable-sm mt-3" responsiveLayout="scroll" 
          v-model:selection="selectedTanks" @rowUnselect="onTankUnSelect"  @rowSelect="onTankSelect" @rowSelectAll="this.tanksToExclude = []">
            <Column selectionMode="multiple" headerStyle="width: 3em" :reorderableColumn="false"></Column>
            <Column field="equipmentCode" :header="$t('issueOfDocuments.tanks')" :sortable="true">
              <template #body="{ data, field }">
                <span>{{data[field]}}</span>
              </template>
            </Column>
            <Column field="isPushInLine" :header="$t('issueOfDocuments.isPushInLine')" :sortable="true">
              <template #body="{ data, field }">
                <span>{{data[field] ? $t('yes') : $t('no')}}</span>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <template #footer>
        <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text p-button-danger" @click="openDialogBlackProducts = false; this.tanksToExclude = []"/>
        <ResponsiveButton :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="createNewVersion" />
      </template>
    </Dialog>
    <Dialog v-model:visible="openDialogBlackProductsRecreate" modal class="p-fluid" :closable="false" :style="{ width: '50rem' }">
      <div class="grid">
        <div class="field col-12">
          <span><b>{{ this.$t('issueOfDocuments.blackProductsTank') }}</b></span>
          <DataTable :value="blackProductsTankList" showGridlines stripedRows class="p-datatable-sm mt-3" responsiveLayout="scroll" 
          v-model:selection="selectedTanks" @rowUnselect="onTankUnSelect"  @rowSelect="onTankSelect" @rowSelectAll="this.tanksToExclude = []">
           <Column selectionMode="multiple" headerStyle="width: 3em" :reorderableColumn="false"></Column>
            <Column field="equipmentCode" :header="$t('issueOfDocuments.tanks')" :sortable="true">
              <template #body="{ data, field }">
                <span>{{data[field]}}</span>
              </template>
            </Column>
            <Column field="isPushInLine" :header="$t('issueOfDocuments.isPushInLine')" :sortable="true">
              <template #body="{ data, field }">
                <span>{{data[field] ? $t('yes') : $t('no')}}</span>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <template #footer>
        <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text p-button-danger" @click="openDialogBlackProductsRecreate = false; this.tanksToExclude = []"/>
        <ResponsiveButton :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="submitRecreateDocument" />
      </template>
    </Dialog>
    <div class="m-5">
      <div class="grid">
        <div class="col-12 field">
          <Button :label="$t('btn.recreate')" icon="pi pi-replay" class="p-button-danger mr-2" @click="recreateDocument" v-if="!uiPermissions('issueOfDocumentsRecreateDocumentButton').isHidden && currentVersion" :disabled="!uiPermissions('issueOfDocumentsRecreateDocumentButton').isEnabled || !isActive"/>
          <Button :label="$t('btn.close')" icon="pi pi-lock" class="p-button-success mr-2" @click="closeDocument" v-if="!uiPermissions('issueOfDocumentsCloseDocumentButton').isHidden && currentVersion" :disabled="!uiPermissions('issueOfDocumentsCloseDocumentButton').isEnabled || !isActive"/>
          <Button :label="$t('btn.reOpen')" icon="pi pi-lock-open" class="p-button-warning mr-2" @click="reOpenDocument" v-if="!uiPermissions('issueOfDocumentsReOpenDocumentButton').isHidden && currentVersion" :disabled="!uiPermissions('issueOfDocumentsReOpenDocumentButton').isEnabled || !isClosed"/>
          <Button :label="$t('btn.print')" icon="pi pi-print" class="p-button-primary mr-2" @click="printFascicle" v-if="!uiPermissions('issueOfDocumentsPrintFascicleButton').isHidden && currentVersion" :disabled="!uiPermissions('issueOfDocumentsPrintFascicleButton').isEnabled"/>
        </div>
        <div class="col-12 lg:col-6 field">
          <label for="voyageNumber">{{$t('issueOfDocuments.voyage')}}</label>
          <GenericCustomAutocompleteV2
            :onItemSelect="onVoyageSelected"
            v-model="idMovementInstructionHeader"
            name="voyageNumber"
            id="voyageNumber"
            ref="voyageCombo"
            :format="{ label: 'label', value: 'value' }"
            api="movement-instruction/voyage-number-combo?getOnlyOpened=true"
            class="w-full p-inputtext-sm" />
            <div>
              <Checkbox
              v-model="onlyOpened" 
              :binary="true" 
              name="onlyOpened"
              class="mt-2 mr-2"/>
              <label for="onlyOpened">{{$t('timesheet.onlyOpenedVoyage')}}</label>  
            </div>
        </div>
        <div class="col-12 lg:col-6 field">
          <label for="documentVersion">{{$t('issueOfDocuments.documentVersion')}}</label>
          <Dropdown
            :disabled="!versions.length"
            :options="versions"
            optionLabel="label"
            class="w-full p-inputtext-sm mt-1"
            v-model="currentVersion" />       
        </div>
        <div class="col-12 lg:col-6 field">
          <p v-if="currentVersion && currentVersion.extraData && currentVersion.extraData.isClosed">{{ currentVersion.valueString }}</p>
        </div>
        <div class="col-12">
          <Panel header="Documents" :toggleable="true" v-model:collapsed='collapseDocumentsPanel'>
            <TabView v-model:activeIndex="activeTab">
              <TabPanel v-for="section in activeSections" :header="$t(section)" :key="section" >
                <DataTable ref="items" :reorderableColumns="true" :value="documents[section]" v-model:selection="selectedDocument" selectionMode="single">
                  <Column :exportable="false">
                    <template #body="slotProps">
                        <Button icon="pi pi-eye" class="p-button-rounded p-button-success mr-2" v-tooltip="$t('btn.preview')" @click="print(slotProps.data, true)" />
                        <Button icon="pi pi-print" class="p-button-rounded p-button-warning mr-2" v-tooltip="$t('btn.print')" @click="print(slotProps.data, false)" />
                        <Button icon="pi pi-ticket" class="p-button-rounded p-button-primary mr-2" v-tooltip="$t('btn.assignLocalNumber')" @click="assignLocalNumber(slotProps.data, $event)" v-if="slotProps.data.type === 'NP' || slotProps.data.type === 'BEM' || slotProps.data.type === 'PLZ' || slotProps.data.type === 'XAB'"/>
                    </template>
                  </Column>
                  <div v-for="field in config.documentFields" :key="field">
                    <Column :field="field" :header="$t('issueOfDocuments.' + field)"></Column>
                  </div>
                  <template #empty>
                    {{$t('noRecordsFound')}}
                  </template>
                </DataTable>
              </TabPanel>
            </TabView>
          </Panel>
        </div>
      </div>
      <div class="grid mt-3">
        <Panel header="Details" :toggleable="true" v-model:collapsed='collapseDocumentDetailsPanel' class="col-12">
          <div class="grid">
            <div class="col-12">
              <h3>{{ this.selectedDocument.typeDescription ? (this.selectedDocument.typeDescription + ' | ' +this.selectedDocument.lot) : ''}}</h3>
              <ResponsiveButton
                v-if="!uiPermissions('issueOfDocumentsSaveButton').isHidden && this.selectedDocument.type && documentDetails[this.selectedDocument.type].id && !isPreviousVersion"
                :disabled="!uiPermissions('issueOfDocumentsSaveButton').isEnabled"
                :label="$t('btn.save')" 
                icon="pi pi-save" 
                class="p-button-outlined p-button-sm m-1" 
                @click="handleDocumentDetails(true)" />
            </div>
            <template v-if="this.selectedDocument.type">
              <template v-for="key in Object.keys(documentDetails[this.selectedDocument.type])" :key="key">
                <template v-if="!Array.isArray(documentDetails[this.selectedDocument.type][key])" >
                  <template v-if="!config.documentType[this.selectedDocument.type][key]?.hidden">
                    <div v-if="config.documentType[this.selectedDocument.type][key]?.type === 'text'" class="col-12 lg:col-3" >
                      <label :class="{'p-error':v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted}" :for="key" >{{ $t('issueOfDocuments.' + this.selectedDocument.type + '.' + key) }}</label>
                      <InputText 
                        :class="{'p-invalid':v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted}"
                        :disabled="isPreviousVersion || config.documentType[this.selectedDocument.type][key].readonly"
                        :id="key"
                        type="text"
                        v-model="documentDetails[this.selectedDocument.type][key]"
                        class="w-full p-inputtext-sm m-1" />
                      <div v-if="(v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted) || v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$pending.$response">
                        <small class="p-error" v-for="error in v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                      </div>
                    </div>
                    <div v-if="config.documentType[this.selectedDocument.type][key]?.type === 'number'" class="col-12 lg:col-3" >
                      <label :class="{'p-error':v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted}" 
                        :for="key">
                        {{ $t('issueOfDocuments.' + this.selectedDocument.type + '.' + key) }}
                      </label>
                      <InputNumber 
                        :class="{'p-invalid':v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted}"
                        :disabled="isPreviousVersion || config.documentType[this.selectedDocument.type][key].readonly" 
                        :id="key" 
                        v-model="documentDetails[this.selectedDocument.type][key]" 
                        class="w-full m-1" />
                      <div v-if="(v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted) || v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$pending.$response">
                        <small class="p-error" v-for="error in v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                      </div>
                    </div>
                    <div v-if="config.documentType[this.selectedDocument.type][key]?.type === 'decimal'" class="col-12 lg:col-3" >
                      <label :class="{'p-error':v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted}" 
                        :for="key">
                        {{ $t('issueOfDocuments.' + this.selectedDocument.type + '.' + key) }}
                      </label>
                      <InputNumber 
                        :class="{'p-invalid':v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted}"
                        :disabled="isPreviousVersion || config.documentType[this.selectedDocument.type][key].readonly" 
                        :id="key" 
                        :minFractionDigits="config.documentType[this.selectedDocument.type][key].decimals"
                        :maxFractionDigits="config.documentType[this.selectedDocument.type][key].decimals"
                        v-model="documentDetails[this.selectedDocument.type][key]" 
                        class="w-full m-1" />
                      <div v-if="(v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted) || v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$pending.$response">
                        <small class="p-error" v-for="error in v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                      </div>
                    </div>
                    <div v-if="config.documentType[this.selectedDocument.type][key]?.type === 'textarea'" class="col-12 lg:col-3" >
                      <label :class="{'p-error': v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted}" :for="key">{{ $t('issueOfDocuments.' + this.selectedDocument.type + '.' + key) }}</label>
                      <Textarea 
                        :class="{'p-invalid':v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted}"
                        :disabled="isPreviousVersion || config.documentType[this.selectedDocument.type][key].readonly" 
                        :id="key" 
                        v-model="documentDetails[this.selectedDocument.type][key]" 
                        class="w-full m-1" />
                      <div v-if="(v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted) || v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$pending.$response">
                        <small class="p-error" v-for="error in v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                      </div>
                    </div>
                    <div v-if="config.documentType[this.selectedDocument.type][key]?.type === 'date'" class="col-12 lg:col-3" >
                      <label :class="{'p-error':v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted}" :for="key">{{ $t('issueOfDocuments.' + this.selectedDocument.type + '.' + key) }}</label>
                      <GenericDateTimeMaskV2 
                        :class="{'p-invalid':v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted}"
                        v-model="documentDetails[this.selectedDocument.type][key]"
                        :readonly="isPreviousVersion || config.documentType[this.selectedDocument.type][key].readonly"
                        inputClass="w-full" />
                        <div v-if="(v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted) || v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$pending.$response">
                          <small class="p-error" v-for="error in v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$silentErrors" :key="error.$validator">
                              {{error.$message}}
                          </small>
                        </div>
                    </div>
                    <div v-if="config.documentType[this.selectedDocument.type][key]?.type === 'dateOnly'" class="col-12 lg:col-3" >
                      <label :class="{'p-error':v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted}" :for="key">{{ $t('issueOfDocuments.' + this.selectedDocument.type + '.' + key) }}</label>
                      <Calendar 
                        :class="{'p-invalid':v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted}"
                        v-model=" documentDetails[this.selectedDocument.type][key]"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" 
                        :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                        :dateFormat="constants.DATE_FORMAT_POINT"
                        class="w-full"
                        />
                      <div v-if="(v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$invalid && documentSubmitted) || v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$pending.$response">
                        <small class="p-error" v-for="error in v$.documentDetails[this.selectedDocument.type][key] && v$.documentDetails[this.selectedDocument.type][key].$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                      </div>
                    </div>
                  </template>
                </template>
              </template> 
            </template>
          </div>
        </Panel>
        <template v-if="selectedDocument.type && documentDetails?.[this.selectedDocument.type]">
          <template v-for="key in Object.keys(documentDetails[this.selectedDocument.type])" :key="key">
            <template v-if="Array.isArray(documentDetails[this.selectedDocument.type][key]) && (this.selectedDocument.type !== 'SHT') && documentDetails[this.selectedDocument.type][key].length">
              <Panel header="Items" :toggleable="true" v-model:collapsed='collapseDocumentItemsPanel' class="col-12">
                <div class="grid">
                  <div class="col-12">
                    <DataTable :reorderableColumns="true" :value="documentDetails[this.selectedDocument.type][key]" showGridlines stripedRows>
                      <template #header>
                        <Toolbar>
                          <template #start>
                              <div class="custom-card-title">{{$t('movementInstructions.measureUnits')}}</div>
                          </template>
                          <template #end>
                              <ResponsiveButton :label="$t('btn.add')" icon="pi pi-plus" class="p-button-outlined p-button-sm" @click="openMeasureUnitDialog" v-if="!isPreviousVersion" />
                          </template>
                      </Toolbar>
                      </template>
                      <Column :exportable="false" style="min-width:8rem" :reorderableColumn="false" v-if="!isPreviousVersion">
                        <template #body="slotProps">
                            <ResponsiveButton icon="pi pi-pencil" class="grid-action-btn p-button-rounded p-button-outlined" @click="openMeasureUnitDialogEdit(slotProps.data)" />
                            <ResponsiveButton icon="pi pi-trash" class="grid-action-btn p-button-rounded p-button-outlined" @click="onDeleteMeasureUnit(slotProps.data, $event)" />
                        </template>
                      </Column>
                      <template v-for="item in Object.entries(documentDetails[this.selectedDocument.type][key][0])" :key="item">
                        <Column 
                        v-if="!config.documentItems[this.selectedDocument.type][item[0]]?.hidden &&
                        config.documentItems[this.selectedDocument.type][item[0]]?.type !== 'comboKey'"
                        :field="item[0]"
                        :header="$t('issueOfDocuments.' + this.selectedDocument.type + '.items.' + item[0])"
                        :sortable="true"
                        >
                      </Column>
                      </template>
                      <template #empty>
                        {{$t('noRecordsFound')}}
                      </template>
                    </DataTable>
                  </div>
                </div>
              </Panel>
            </template>   
          </template>
        </template>
      </div>
    </div>
  </main>
</template>
